// extracted by mini-css-extract-plugin
module.exports = {"box":"cards_box__3Epn2","mobile-cards":"cards_mobile-cards__2tOwz"};